module.exports = __webpack_public_path__ + "pc-top-assets/img/instagram.4388028e.svg";